import React from "react";
import DayPicker from "react-day-picker";
import ComponentWrapper from "./ComponentWrapper";
import { useTranslation } from "../../i18n/TranslationProvider";

const Calendar = ({ selectedDays, onDayClick, modifiers }) => {
  const { t } = useTranslation();

  const months = [
    t("months.january"), t("months.february"), t("months.march"),
    t("months.april"), t("months.may_long"), t("months.june"),
    t("months.july"), t("months.august"), t("months.september"),
    t("months.october"), t("months.november"), t("months.december"),
  ];

  const weekdaysLong = [
    t("days.long.sunday"), t("days.long.monday"), t("days.long.tuesday"),
    t("days.long.wednesday"), t("days.long.thursday"),
    t("days.long.friday"), t("days.long.saturday"),
  ];

  const weekdaysShort = [
    t("days.short.sunday"), t("days.short.monday"), t("days.short.tuesday"),
    t("days.short.wednesday"), t("days.short.thursday"),
    t("days.short.friday"), t("days.short.saturday"),
  ];

  const modifiersStyles = {
    tracked: { color: "white", backgroundColor: "green" },
    untracked: { color: "white", backgroundColor: "red" },
  };

  return (
    <ComponentWrapper>
      <DayPicker
        modifiers={modifiers}
        onDayClick={onDayClick}
        selectedDays={selectedDays}
        modifiersStyles={modifiersStyles}
        disabledDays={(day) => day > new Date()}
        months={months}
        weekdaysLong={weekdaysLong}
        weekdaysShort={weekdaysShort}
      />
    </ComponentWrapper>
  );
};

export default Calendar;